<template>
    <Card :title="$t('labels.arrival_declaration')">
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-sm-6 col-xl-3">
                    <FormGroup :label="$t('labels.warehouse')">
                        <Select
                            :model-value="arrivalDeclaration?.warehouse_id"
                            :selected-value="selectedWarehouse?.name"
                            :options="warehouses"
                            option-key="id"
                            :disabled="true"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <FormGroup :label="$t('labels.supplier')">
                        <Select
                            :model-value="arrivalDeclaration?.supplier_id"
                            :selected-value="selectedSupplier?.name"
                            :options="suppliers"
                            option-key="id"
                            :disabled="true"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.currency')">
                        <Select
                            :model-value="selectedCurrency?.uuid"
                            :selected-value="selectedCurrency?.name"
                            @update:model-value="$emit('update:selected-currency', $event)"
                            :options="currencies"
                            :disabled="canModify"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.rate')">
                        <Input
                            type="number"
                            :model-value="arrivalDeclaration?.currency_rate"
                            @update:model-value="$emit('update:currency-rate', $event)"
                            :disabled="canModify"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.status')">
                        <Select
                            :model-value="selectedStatus?.uuid"
                            :selected-value="selectedStatus?.name"
                            @update:model-value="$emit('update:selected-status', $event)"
                            :options="arrivalDeclarationStatuses"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" style="gap: .5rem">
            <AppButton color="light" @click="$emit('delete')">
                <i class="icon-trash mr-2"></i>
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton color="indigo" @click="$emit('edit')">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>

<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Select from '../../../../../components/new/form/select/AppSelect.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

import MessageNotificator from '../../../../../services/MessageNotificator';
import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: 'ArrivalDeclarationCard',
    components: {
        Card,
        FormGroup,
        Select,
        Input,
        AppButton
    },
    props: {
        arrivalDeclaration: {
            type: Object,
            default: null
        },
        selectedCurrency: {
            type: Object,
            default: null
        },
        selectedStatus: {
            type: Object,
            default: null
        },
        arrivalDeclarationStatuses: {
            type: Array,
            default: []
        },
        selectedWarehouse: {
            type: Object,
            default: null
        },
        selectedSupplier: {
            type: Object,
            default: null
        },
        currencies: {
            type: Array,
            default: []
        },
        suppliers: {
            type: Array,
            default: []
        },
        warehouses: {
            type: Array,
            default: []
        }
    },
    emits: ['update:selected-currency', 'update:currency-rate', 'update:selected-status', 'delete', 'edit'],
    computed: {
        canModify() {
            if (!this.arrivalDeclaration) {
                return true
            }

            let statusType = this.arrivalDeclaration.arrival_declaration_status.type

            return statusType === 'done' || statusType === 'fail' 
        },
    }
}
</script>
